module.exports = __webpack_public_path__ + "media/components/src/assets/images/tables/block_table_7-58307545493bc924d5d7472f38895d92.jpg";